import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Cell } from 'recharts'
import { DEFAULT_LANGUAGE } from '../../../../../../../../../../../configs/language'
import { ChartContainer } from '../../../../../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../../../../../../common/chart/legend'
import { Element } from '../../../../../../../../../../common/html/element'
import { Radio } from '../../../../../../../../../../common/html/radio'
import { Notification } from '../../../../../../../../../../common/notification'
import {
  formatVal,
  valToPercent,
} from '../../../../../../../../../../helpers/value'
import {
  COLOR_CHART_DISTRIBUTION,
  TYPE_RADIO_DISTRIBUTION,
} from '../../../creditRiskScore/bottomContent/constant'
import classes from '../index.module.scss'
import {
  changeTypeRadioDynamicPerformance,
  selectChartDistribution,
  selectChartTrendOfScore,
} from '../store/slice'

export const DistributionChart = ({ isDynamicReport, type }) => {
  const dispatch = useDispatch()

  const dataIndustry = useSelector(selectChartDistribution('industry'))
  const dataRegion = useSelector(selectChartDistribution('region'))
  const dataYear = useSelector(selectChartDistribution('year'))
  const dataTrend = useSelector(selectChartTrendOfScore)
  const locale = useSelector((state) => state.i18n.locale)

  const [typeRadio, setTypeRadio] = useState(
    isDynamicReport ? type : Object.keys(TYPE_RADIO_DISTRIBUTION)[0],
  )

  let textDes = {}
  const data = useMemo(() => {
    switch (typeRadio) {
      case 'industry':
        textDes = {
          title: 'score.premium.FOOTER.INDUSTRY',
          translateProps: {
            description:
              dataTrend.find((item) => !!item?.description2)?.description2 ||
              '',
          },
        }
        return dataIndustry
      case 'region':
        textDes = {
          title: 'score.premium.FOOTER.REGION',
          translateProps: {
            description:
              dataTrend.find((item) => !!item?.description3)?.description3 ||
              '',
          },
        }
        return dataRegion
      case 'year':
        textDes = {
          title: 'score.premium.FOOTER.YEAR_OF',
          translateProps: {
            description:
              dataTrend.find((item) => !!item?.description4)?.description4 ||
              '',
          },
        }
        return dataYear
      default:
        return []
    }
  })

  //Legend
  const legendItems = [
    {
      title: 'score.premium.DISTRIBUTION.TEXT_LENGEND',
      isI18n: true,
      color: COLOR_CHART_DISTRIBUTION.ACTIVE,
    },
    {
      title: textDes.title,
      isI18n: true,
      translateProps: textDes.translateProps,
      color: COLOR_CHART_DISTRIBUTION.NOT_ACTIVE,
    },
  ]

  //Tooltip
  const renderCustomContent = ({ data, renderTooltipLabel }) => {
    return (
      <>
        <div>{renderTooltipLabel()}</div>
        <div>{valToPercent(data.percentage, locale, 0, 0, 1)}</div>
      </>
    )
  }

  const changeTypeRadio = (value) => {
    dispatch(changeTypeRadioDynamicPerformance(value))
    setTypeRadio(value)
  }

  useEffect(() => {
    dispatch(changeTypeRadioDynamicPerformance(typeRadio))
  }, [])

  const renderContent = (dynamic) => {
    const chart = () => (
      <>
        <ChartContainer
          data={data}
          width="100%"
          height={280}
          margin={{ left: 0, right: 0 }}
          xAxis={[{ dataKey: 'ticker', height: 30, lineClamp: 2 }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: ['percentage'],
              isBarChart: true,
              tickFormatter: (val) =>
                formatVal(val * 100, DEFAULT_LANGUAGE, 0, 0),
              unit: '%',
            },
          ]}
          tooltip={{
            schema: {
              renderCustomContent,
            },
          }}
        >
          <Bar yAxisId="left" dataKey="percentage" barSize={36} fill="#facc5c">
            {data.map((entry) => (
              <Cell
                key={entry.scoreRangeId}
                fill={
                  entry.companyBelongTo
                    ? COLOR_CHART_DISTRIBUTION.ACTIVE
                    : COLOR_CHART_DISTRIBUTION.NOT_ACTIVE
                }
              />
            ))}
          </Bar>
        </ChartContainer>
        <div style={{ paddingBottom: 8 }}>
          <Element style={{ lineHeight: '16px', color: '#3A414B' }}>
            <Translate value="score.premium.FOOTER.TEXT_NOTI1" />
          </Element>
        </div>
      </>
    )
    const legend = () => (
      <Legend items={legendItems} style={{ flexDirection: 'column' }} />
    )
    if (dynamic) {
      return (
        <div className="dFlex w100">
          <div className="w70"> {chart()}</div>
          <div className="w30 pl2 pt3">{legend()}</div>
        </div>
      )
    }

    return (
      <>
        {chart()}
        {legend()}
      </>
    )
  }

  return (
    <div className={classes.distribution}>
      <Element
        style={{
          color: '#191D25',
          lineHeight: '16px',
          fontWeight: 600,
          paddingBottom: 8,
        }}
      >
        <Translate value="score.premium.DISTRIBUTION.NAME_CHART" />
      </Element>
      {!data.length && isDynamicReport ? (
        <></>
      ) : (
        <Element
          className={classes.groupRadio}
          style={{
            lineHeight: '16px',
            color: '#3A414B',
            justifyContent: isDynamicReport ? 'start' : 'center',
          }}
        >
          {Object.values(TYPE_RADIO_DISTRIBUTION).map((item) => {
            return (
              <div key={item.name}>
                <Radio
                  value={item.name}
                  activeValue={typeRadio}
                  onChange={changeTypeRadio}
                  title={`score.premium.DISTRIBUTION.${item.name.toUpperCase()}`}
                  mlTitle={5}
                />
              </div>
            )
          })}
        </Element>
      )}
      {!!data.length ? (
        <>{renderContent(isDynamicReport)}</>
      ) : (
        <>
          <Notification />
        </>
      )}
    </div>
  )
}
